import { Textarea, TextareaProps } from "@hightouch/htui";
import { Controller, useFormContext } from "react-hook-form";
import { SharedProps } from ".";

export const FKTextArea = ({
  name,
  error,
  placeholder,
  isDisabled,
}: TextareaProps & SharedProps) => {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <Textarea
          isDisabled={isDisabled}
          isInvalid={Boolean(error)}
          placeholder={placeholder}
          resize="vertical"
          rows={10}
          width="100%"
          value={field.value}
          onBlur={field.onBlur}
          onChange={field.onChange}
        />
      )}
    />
  );
};
